<template>
  <b-modal
    ref="modal"
    :size="size || 'xl'"
    :title="title"
    scrollable
    no-close-on-backdrop
    @shown="handleFocus"
    @ok="updateAndClose"
    @cancel="cancelAndClose"
  >
    <div slot="modal-header" class="d-flex" style="width: 100%">
      <div>
        <b-button-group>
          <b-input-group>
            <b-form-input
              ref="filterInput"
              v-model="filterInput"
              placeholder="Type to Search"
            />
            <b-input-group-append>
              <b-button
                variant="outline-light"
                :disabled="!filterInput"
                @click="filterInput = ''"
                ><Icon2 icon="Search_backspace"
              /></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-button-group>
        <b-button
          v-if="showNewButton"
          class="ml-2"
          variant="link"
          @click="addNew"
        >
          <font-awesome-icon icon="plus-circle" />
          <span class="ml-2">New</span>
        </b-button>
      </div>

      <div class="flex-grow-1">
        <div
          class="selected-items d-flex flex-row-reverse flex-wrap align-items-stretch"
          style="width: 100%"
        >
          <span class="item" v-for="v in valuesCopy" :key="v">
            <b-badge variant="info" class="mx-1">
              {{ v }}
              <b-badge href="#" @click.stop="removeItem(v)">&#x2716;</b-badge>
            </b-badge>
          </span>
        </div>
      </div>
    </div>

    <small class="text-muted ml-1 mb-1" style="font-size: 0.8rem">{{
      filterInput
        ? filteredItems && filteredItems.length > 0
          ? "SEARCH RESULTS"
          : "NO RESULTS"
        : "LATEST"
    }}</small>

    <div class="d-flex flex-wrap" style="width: 100%">
      <span
        class="item"
        v-for="v in filteredItems"
        :key="v.value"
        style="font-size: 1.2rem"
      >
        <b-badge
          variant="primary"
          class="mx-1 mb-2"
          href="#"
          @click.stop="selectItem(v)"
        >
          {{ v.value }}
        </b-badge>
      </span>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "SelectBox2",

  data: function () {
    return {
      columnCount: 4,
      valuesCopy: [],
      itemsCopy: [],
      filterInput: "",
      debouncedUpdateItems: null,
    };
  },

  props: {
    title: String,
    size: String,
    values: Array,
    items: Array,
    labelType: { type: String, default: "label" },
    allowNew: Boolean,
  },

  watch: {
    items() {
      this.itemsCopy = this.$_.clone(this.items);
    },

    filterInput(value) {
      if (this.debouncedUpdateItems) this.debouncedUpdateItems(value);
      else this.updateItems(value);
    },
  },

  computed: {
    url() {
      switch (this.labelType) {
        case "artist":
          return "/admin/api/v2/artists/search/";

        case "genre":
          return "/admin/api/v2/genres/search/";

        default:
          return "/admin/api/v2/labels/search/";
      }
    },

    showNewButton() {
      if (this.allowNew && this.filterInput && this.filterInput.length > 0) {
        if (this.itemsCopy.length > 0) {
          return (
            this.itemsCopy.filter((item) => item.value == this.filterInput)
              .length == 0
          );
        }

        return true;
      }
      return false;
    },

    filteredItems() {
      return this.itemsCopy.filter((item) => !item.selected);
    },
  },

  methods: {
    show() {
      this.valuesCopy = this.$_.clone(this.values);
      this.itemsCopy = this.$_.clone(this.items);
      this.$refs.modal.show();
    },

    updateItems(filterString) {
      if (filterString == "") {
        this.itemsCopy = this.$_.clone(this.items);
      } else {
        fetch(this.url + filterString)
          .then(function (resp) {
            return resp.json();
          })
          .then((resp) => {
            this.itemsCopy = resp.data.map((k) => {
              const selected = this.valuesCopy.indexOf(k) >= 0;
              return { value: k, text: k, selected: selected };
            });
          });
      }
    },

    selectItem(item) {
      item.selected = !item.selected;

      if (item.selected) {
        this.valuesCopy.push(item.value);
      } else {
        const ndx = this.valuesCopy.indexOf(item.value);
        if (ndx >= 0) this.$delete(this.valuesCopy, ndx);
      }

      this.handleFocus();
    },

    removeItem(value) {
      const ndx = this.valuesCopy.indexOf(value);
      if (ndx >= 0) {
        this.$delete(this.valuesCopy, ndx);
        this.itemsCopy = this.itemsCopy.map((item) => {
          if (item.value == value) item.selected = false;
          return item;
        });
      }
    },

    close() {
      this.itemColumns = [];
      if (this.itemsCopy && this.itemsCopy.length > 0) {
        this.itemsCopy = this.itemsCopy.map((i) => {
          i.selected = false;

          return i;
        });
      }

      let state = this.$store.state.media.modals.labels;
      state.visible = false;
      this.$store.commit("media/updateModal", { labels: state });
    },

    cancelAndClose() {
      this.$emit("update");
      this.close();
    },

    updateAndClose() {
      this.close();
      this.$emit("update", this.valuesCopy);
    },

    handleFocus() {
      this.$refs.filterInput.focus();
    },

    addNew() {
      this.itemsCopy.push({
        value: this.filterInput,
        text: this.filterInput,
        selected: true,
      });
      this.valuesCopy.push(this.filterInput);
    },
  },

  created() {
    this.debouncedUpdateItems = this.$_.debounce(this.updateItems, 300);

    switch (this.size) {
      case "sm":
        this.columnCount = 1;
        break;

      case "md":
        this.columnCount = 2;
        break;

      case "lg":
        this.columnCount = 3;
        break;

      default:
        this.columnCount = 4;
        break;
    }
  },
};
</script>

<style scoped>
.selected-items {
  margin-top: 6px;
  margin-left: -16px;
}
</style>
